var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.bookingInPersonDayBefore &&
    _vm.bookingAppearanceInPerson &&
    !_vm.bookingInPersonCompleted &&
    !_vm.talentConfirmedInPersonAttendance
      ? _c("div", { staticClass: "alert-large alert-large-info" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "alert-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c("p", { staticClass: "lead m-b-none" }, [
                  _vm._v("Confirmation of attendance"),
                ]),
                _vm._v(" "),
                _vm.$userIsTalent
                  ? _c("p", { staticClass: "no-margin" }, [
                      _vm._v(
                        _vm._s(_vm.user.name) +
                          ", please confirm you will be attending this event."
                      ),
                    ])
                  : _c("p", { staticClass: "no-margin" }, [
                      _vm._v("Please confirm "),
                      _c("strong", [_vm._v(_vm._s(_vm.user.name))]),
                      _vm._v(" will be attending this event."),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-success btn-job-complete",
                    on: {
                      click: function ($event) {
                        return _vm.handleConfirmAttendanceCallback("in_person")
                      },
                    },
                  },
                  [
                    _vm.$userIsTalent
                      ? [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(" Yes, I am attending"),
                        ]
                      : [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(
                            " Yes, " + _vm._s(_vm.$starLabel) + " is attending"
                          ),
                        ],
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bookingAppearanceOnline && !_vm.talentConfirmedOnlineParticipation
      ? _c("div", { staticClass: "alert-large alert-large-info" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "alert-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c("p", { staticClass: "lead m-b-none" }, [
                  _vm._v("Online Deliverables: Confirmation of participation"),
                ]),
                _vm._v(" "),
                _vm.$userIsTalent
                  ? _c("p", { staticClass: "no-margin" }, [
                      _vm._v(
                        _vm._s(_vm.user.name) +
                          ", please confirm you will be completing the online requirement for this booking."
                      ),
                    ])
                  : _c("p", { staticClass: "no-margin" }, [
                      _vm._v("Please confirm "),
                      _c("strong", [_vm._v(_vm._s(_vm.user.name))]),
                      _vm._v(
                        " will be completing the online requirement for this booking."
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-success btn-job-complete",
                    on: {
                      click: function ($event) {
                        return _vm.handleConfirmAttendanceCallback("online")
                      },
                    },
                  },
                  [
                    _vm.$userIsTalent
                      ? [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(" Yes, I will complete"),
                        ]
                      : [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(
                            " Yes, " + _vm._s(_vm.$starLabel) + " will complete"
                          ),
                        ],
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-question" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-question" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }